"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const WorldMap_class_1 = __importDefault(require("./WorldMap.class"));
exports.default = (0, vue_1.defineComponent)({
    setup: (props, { emit }) => {
        const component = new WorldMap_class_1.default(emit);
        (0, vue_1.onMounted)(component.mounted.bind(component));
        (0, vue_1.onBeforeUnmount)(component.onBeforeUnmount.bind(component));
        return {
            map: component.map,
            countries: component.countries,
            hoveredCountry: component.hoveredCountry,
            hoveredCountryIso: component.hoveredCountryIso,
            selectedCountryIso: component.countryIsoSelected,
            startMapDraggingInteraction: component.startMapDraggingInteraction.bind(component),
            startMapDraggingInteractionTouch: component.startMapDraggingInteractionTouch.bind(component),
            stopMapDraggingInteraction: component.stopMapDraggingInteraction.bind(component),
            getMapPosition: component.getMapPosition.bind(component),
            updateMapPosition: component.updateMapPosition.bind(component),
            updateMapPositionTouch: component.updateMapPositionTouch.bind(component),
            setAsHovered: component.setAsHovered.bind(component),
            setAsUnHovered: component.setAsUnHovered.bind(component),
            setAsSelected: component.setAsSelected.bind(component),
            mapZoom: component.mapZoom.bind(component)
        };
    }
});
